import { ErrorMessage, Field, Formik, Form } from "formik";
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { Modal as ModalStrap, ModalHeader, ModalBody, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import * as Yup from 'yup';
import { ProductoColaboradorDTO, getVoidProductoColaboradorDTO, setListProductoColaborador } from "../../interfaces/ColaboradorProdcutoDTO";
import { Unidad } from "../../interfaces/Unidad";
import { useEffect, useState } from "react";
import CatalogService, { RolColaboradorProducto } from "../../services/CatalogService";
import { ObjetoLabelFilter } from "../../interfaces/ObjetoLabel";
import { MdAssignmentReturn } from 'react-icons/md';
import { RiSave3Fill } from 'react-icons/ri';
import { CatagNumberDTO } from "../../interfaces/CatalogoDTO";
import ProyectoService from "../../services/ProyectoService";
import { ProyectoColaboradoreDTO } from "../../interfaces/ProyectoColaboradoreDTO";
import ProductoService from "../../services/ProductoService";
import AlertService from "../../services/AlertService";
import { format, parse } from 'date-fns';
import { AiFillDelete, AiOutlinePlusCircle, AiOutlineSearch, AiOutlineUserAdd } from "react-icons/ai";
import { FaRegAddressCard } from "react-icons/fa";

const catalogService = new CatalogService();
const proyectoService = new ProyectoService();
const productoService = new ProductoService();
const alertaService = new AlertService();

const validationSchema = Yup.object().shape({
    cedula: Yup.string().required('Una identificación es requerida'),
    nombre: Yup.string().required('Nombres son requeridos'),
    institucion: Yup.string().required('Institución es requerida'),
    email: Yup.string().email('Correo no válido').required('Correo es requerido'),
    tipocolaborador: Yup.string().notOneOf(['0'], 'No puede ser ninguno').required('Rol es requerido'),
    tipoparticipacion: Yup.string().notOneOf(['0'], 'No puede ser ninguno').required('Rol es requerido'),
    idunidad: Yup.string().test('anioRequired', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipocolaborador;
        if (tipo === '1') {
            return value !== undefined ? value !== '0' : false; // Verifica que value no sea undefined antes de validar
        }
        return true; // No se aplica la validación en otros casos
    }),
    fechaingresoproyecto: Yup.string().required('Debe ingresar la fecha de ingreso')
        .test('fecha-inicio', 'La fecha de ingreso debe ser mayor o igual a la fecha de inicio del proyecto', function (value) {
            const fechaciniProy = this.parent.fechacIniProy;
            const idproyecto = this.parent.iddecinvproyecto;
            if (fechaciniProy && idproyecto > 0) {
                return new Date(value) >= new Date(fechaciniProy);
            }
            return true; // No se puede validar si la fecha de inicio no está presente
        }),
    fechasalidaproyecto: Yup.string().required('Debe ingresar la fecha de salida')
        .test('fecha-fin', 'La fecha de salida debe ser menor o igual a la fecha de fin del proyecto.', function (value) {
            const fechafinProy = this.parent.fechaFinProy;
            const idproyecto = this.parent.iddecinvproyecto;
            if (fechafinProy && idproyecto > 0) {
                return new Date(value) <= new Date(fechafinProy);
            }
            return true; // No se puede validar si la fecha de inicio no está presente
        }),
});

const buttonStyle = {
    marginTop: '10px', // Ajusta el valor de acuerdo a tu preferencia
};

const tabStyle = {
    cursor: 'pointer', // Cambia el cursor a "pointer" cuando se pasa sobre el botón
};

interface Props {
    colaborador: ProductoColaboradorDTO,
    colProducto: Array<ProductoColaboradorDTO>,
    idinvestigador: number,
    idproducto: number,
    idtipoproducto: number,
    idproyecto: number,
    titulo: string,
    fechainicio: string,
    fechafin: string,
    token: any,
    onResponse?: (dataRespuesta: ProductoColaboradorDTO) => void // Función para pasar la respuesta al padre
}

export default function ColProductoForm(prop: Props) {
    let history = useNavigate()
    const [unidades, setUnidades] = useState<Array<Unidad>>([])
    const [tipoColaborador, setTipoColaborador] = useState<Array<ObjetoLabelFilter>>([])
    const [listRol, setListRol] = useState<Array<ObjetoLabelFilter>>(RolColaboradorProducto)
    const [listRolColaborador, setListRolColaborador] = useState<Array<ObjetoLabelFilter>>(RolColaboradorProducto)
    const [misProyectos, setMisProyectos] = useState<Array<CatagNumberDTO>>([])
    let [colaboradorProyecto, setColaboradorProyecto] = useState<Array<ProyectoColaboradoreDTO>>([])
    let [busquedaUsuario, setBusquedaUsuario] = useState<Array<ProyectoColaboradoreDTO>>([])
    let [open, setOpen] = useState(false);
    let [userModal, setUserModal] = useState(false);
    let [loadingModal, setLoadingModal] = useState(false);
    let [mailBusqueda, setMailBusqueda] = useState('');
    let [apellidosBusqueda, setApellidosBusqueda] = useState('');
    let [tap, setTap] = useState(0);

    useEffect(() => {
        fetchData();
    }, [prop.token]);
    //#region Funciones
    const goToNavigation = (site: string) => {
        history(site)
    }
    const handleOpenModal = () => setOpen(true);
    const toggleOpen = () => {
        setOpen(!open);
    };
    const handleOpenUserModal = () => setUserModal(true);
    const toggleModal = () => {
        setUserModal(!userModal);
    };
    function setListBusqueda(apellidos: string, email: string) {
        setLoadingModal(true);
        proyectoService.GetDatosPersonalesColaborador(apellidos, email, prop.token)
            .then((data) => {
                //console.log(data.objDatos);
                if (data.listData === null) {
                    setBusquedaUsuario([]);
                    setLoadingModal(false);
                } else {
                    setBusquedaUsuario(data.listData);
                    setLoadingModal(false);
                }
            })
            .catch((error) => {
                console.error(error)
                setBusquedaUsuario([]);
                setLoadingModal(false);
            });
    }
    function setListColaboradores() {
        proyectoService.GetColaboradoresProyectoById(prop.idproyecto, prop.token)
            .then((data) => {
                //console.log(data.objDatos);
                setColaboradorProyecto(data.listData);
            })
            .catch((error) => console.error(error));
    }
    const handleEmailBusquedaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        //console.log(value);
        setMailBusqueda(value);
    }
    const handleEmailBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        // Acciones a realizar cuando el campo de entrada pierde el foco
        //console.log('Campo perdió el foco. Valor actual:', mailBusqueda);
    };
    const handleApellidosBusquedaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Actualizar el estado
        if (value !== apellidosBusqueda) {
            setApellidosBusqueda(value);
        }
    }
    const fetchData = async () => {
        //console.log(prop.fechainicio);
        //console.log(prop.fechafin);
        setTipoColaborador(catalogService.getTipoColaborador)
        setListRol(RolColaboradorProducto)
        setListColaboradores();
        await catalogService.obtenerCatalogoUnidades()
            .then((data) => setUnidades(data.objDatos))
            .catch((error) => console.error(error))
        listRolAjust(prop.idtipoproducto)
    }
    const handleAddColaborador = (colaborador: ProyectoColaboradoreDTO, setFieldValue: (arg0: string, arg1: any) => void) => {
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        const fechaNula = new Date(1, 0, 1);
        // Puedes inicializar los valores según tus necesidades
        //console.log(colaborador);
        setFieldValue('iddecinvproyectoprodtermin', prop.idproducto);
        setFieldValue('iddecinvproyectocolaboradores', colaborador.iddecinvproyectocolaboradores);
        setFieldValue('iddecinvproyectoprtercol', 0);
        setFieldValue('iddecinvproyecto', colaborador.iddecinvproyecto);
        setFieldValue('iddecinvrolinvestigador', colaborador.iddecinvrolinvestigador);
        setFieldValue('cedula', colaborador.cedula);
        setFieldValue('tipocolaborador', colaborador.tipocolaborador);
        setFieldValue('tipoparticipacion', 1);
        setFieldValue('nombre', colaborador.nombre);
        setFieldValue('email', colaborador.email.trim());
        setFieldValue('institucion', colaborador.institucion);
        setFieldValue('idunidad', colaborador.idunidad === null ? 0 : colaborador.idunidad);
        setFieldValue('escolabproyecto', 1);
        setFieldValue('enescalafon', colaborador.enescalafon);
        setFieldValue('considerarestimulo', colaborador.considerarestimulo);
        setFieldValue('estimulo', colaborador.estimulo);
        setFieldValue('titulosubproyecto', colaborador.titulosubproyecto);
        setFieldValue('porcentajeparticipacion', colaborador.porcentajeparticipacion || 0);
        const fechacheckescalafon = colaborador.fechacheckescalafon !== null ? format(new Date(colaborador.fechacheckescalafon), "yyyy-MM-dd") : format(fechaNula, "yyyy-MM-dd")
        setFieldValue('fechacheckescalafon', fechacheckescalafon);
        const fechaIn = colaborador.fechaingresoproyecto !== null ? format(new Date(colaborador.fechaingresoproyecto), "yyyy-MM-dd") : format(fechaHoy, "yyyy-MM-dd")
        setFieldValue('fechaingresoproyecto', fechaIn);
        const fechaOut = colaborador.fechasalidaproyecto !== null ? format(new Date(colaborador.fechasalidaproyecto), "yyyy-MM-dd") : format(fechaHoy, "yyyy-MM-dd");
        setFieldValue('fechasalidaproyecto', fechaOut);
        toggleOpen();
    };
    const handleAddPersona = (colaborador: ProyectoColaboradoreDTO, setFieldValue: (arg0: string, arg1: any) => void) => {
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        const fechaNula = new Date(1, 0, 1);
        // Puedes inicializar los valores según tus necesidades
        //console.log(colaborador);
        setFieldValue('iddecinvproyectoprodtermin', prop.idproducto);
        setFieldValue('iddecinvproyectocolaboradores', colaborador.iddecinvproyectocolaboradores);
        setFieldValue('iddecinvproyectoprtercol', 0);
        setFieldValue('iddecinvproyecto', colaborador.iddecinvproyecto);
        setFieldValue('iddecinvrolinvestigador', colaborador.iddecinvrolinvestigador);
        setFieldValue('cedula', colaborador.cedula);
        setFieldValue('tipocolaborador', colaborador.tipocolaborador);
        setFieldValue('tipoparticipacion', 1);
        setFieldValue('nombre', colaborador.nombre);
        setFieldValue('email', colaborador.email.trim());
        setFieldValue('institucion', colaborador.institucion);
        setFieldValue('idunidad', colaborador.idunidad === null ? 0 : colaborador.idunidad);
        setFieldValue('escolabproyecto', 1);
        setFieldValue('enescalafon', colaborador.enescalafon);
        setFieldValue('considerarestimulo', colaborador.considerarestimulo);
        setFieldValue('estimulo', colaborador.estimulo);
        setFieldValue('titulosubproyecto', colaborador.titulosubproyecto);
        setFieldValue('porcentajeparticipacion', colaborador.porcentajeparticipacion || 0);
        const fechaEscalafon = colaborador.fechacheckescalafon ? format(new Date(colaborador.fechacheckescalafon), "yyyy-MM-dd") : format(fechaNula, "yyyy-MM-dd");
        setFieldValue('fechacheckescalafon', fechaEscalafon);
        const fechaIn = colaborador.fechaingresoproyecto ? format(new Date(colaborador.fechaingresoproyecto), "yyyy-MM-dd") : format(fechaHoy, "yyyy-MM-dd")
        setFieldValue('fechaingresoproyecto', fechaIn);
        const fechaOut = colaborador.fechasalidaproyecto ? format(new Date(colaborador.fechasalidaproyecto), "yyyy-MM-dd") : format(fechaHoy, "yyyy-MM-dd");
        setFieldValue('fechasalidaproyecto', fechaOut);
        toggleModal();
    };
    function isColaboradorDelProducto(colaborador: ProyectoColaboradoreDTO): boolean {
        let bandera = false;
        const colEncontrado = prop.colProducto.find(x => (x.email === colaborador.email || x.cedula === colaborador.cedula));
        if (colEncontrado) {
            bandera = true;
        }
        return bandera;
    };
    function usoParticipacion(id: number): boolean {
        let flat = false;
        if ([32, 34].includes(id)) {
            flat = true;
        }
        return flat;
    }
    const save = async (values: any) => {
        console.log("Post: ", values);
        alertaService.showLoading("Espere...");
        let object = getVoidProductoColaboradorDTO();
        object.fechasalidaproyecto = values.fechasalidaproyecto;
        object.fechaingresoproyecto = values.fechaingresoproyecto;
        object.idunidad = parseInt(values.idunidad);
        object.tipoparticipacion = values.tipoparticipacion;
        object.tipocolaborador = values.tipocolaborador;
        object.email = values.email;
        object.institucion = values.institucion;
        object.nombre = values.nombre;
        object.cedula = values.cedula;
        object.iddecinvproyectoprtercol = values.iddecinvproyectoprtercol;
        object.iddecinvproyectoprodtermin = values.iddecinvproyectoprodtermin;
        object.iddecinvproyectocolaboradores = values.iddecinvproyectocolaboradores;
        object.iddecinvproyecto = prop.idproyecto;
        object.iddecinvrolinvestigador = values.iddecinvrolinvestigador;
        object.ultimoCambio = values.ultimoCambio;
        object.escolabproyecto = values.escolabproyecto ?? 0;
        object.enescalafon = values.enescalafon ?? '';
        object.considerarestimulo = values.considerarestimulo ?? '';
        object.estimulo = values.estimulo ?? '';
        object.titulosubproyecto = values.titulosubproyecto ?? '';
        object.fechacheckescalafon = values.fechacheckescalafon;
        object.porcentajeparticipacion = values.porcentajeparticipacion;
        console.log(object);
        const resp = await productoService.GuardarColaboradorProductoTerminadoContext(object, prop.token);
        alertaService.hideLoading();
        //console.log(resp);
        if (resp.status.isSuccessfully) {
            if (prop.onResponse) {
                prop.onResponse(resp.data);
            } else {
                console.error('La función onResponse no está definida.');
            }
        } else {
            alertaService.alertaAdvertenciaList("Alerta", resp.status.messages);
        }
    }
    function listRolAjust(id: number) {
        //INV -> Inventores
        //El set no responde bien al momento de editar
        //setListRol(catalogService.getRolColaboradorProducto)
        //console.log(listRol);
        switch (id) {
            case 29:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'T')));
                break;
            case 30:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'T')));
                break;
            case 32:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'INV')));
                break;
            case 34:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'INV')));
                break;
            case 35:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'C')));
                break;
            case 37:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'U')));
                break;
            case 39:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'A' || x.visibilidad === 'I')));
                break;
            case 41:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'E' || x.visibilidad === 'T')));
                break;
            case 42:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'T')));
                break;
            default:
                setListRolColaborador(listRol.filter(x => x.visibilidad === 'S'));
                break;
        }
    }
    //#endregion
    return (
        <Box component="section" sx={{ p: 2, border: '1px solid black', borderColor: '#0288d1', borderRadius: 5 }}>
            <Formik sx={{ m: 1 }}
                initialValues={{
                    iddecinvproyectoprtercol: prop.colaborador.iddecinvproyectoprtercol,
                    iddecinvproyectoprodtermin: prop.idproducto,
                    tipoparticipacion: prop.colaborador.tipoparticipacion,
                    iddecinvproyectocolaboradores: prop.colaborador.iddecinvproyectocolaboradores,
                    iddecinvproyecto: prop.idproyecto,
                    tipocolaborador: prop.colaborador.tipocolaborador,
                    cedula: prop.colaborador.cedula,
                    nombre: prop.colaborador.nombre,
                    email: prop.colaborador.email,
                    iddecinvrolinvestigador: prop.colaborador.iddecinvrolinvestigador,
                    ultimoCambio: prop.colaborador.ultimoCambio.length > 0 ? format(parse(prop.colaborador.ultimoCambio, "dd/MM/yyyy H:mm:ss", new Date()), "yyyy-MM-dd") : format(new Date(), 'yyyy-MM-dd'),
                    institucion: prop.colaborador.institucion,
                    idunidad: prop.colaborador.idunidad,
                    escolabproyecto: prop.colaborador.escolabproyecto,
                    enescalafon: prop.colaborador.enescalafon,
                    considerarestimulo: prop.colaborador.considerarestimulo,
                    estimulo: prop.colaborador.estimulo,
                    titulosubproyecto: prop.colaborador.titulosubproyecto,
                    fechacheckescalafon: prop.colaborador.fechacheckescalafon.length > 0 ? format(parse(prop.colaborador.fechacheckescalafon, "dd/MM/yyyy H:mm:ss", new Date()), "yyyy-MM-dd") : format(new Date(), 'yyyy-MM-dd'),
                    fechaingresoproyecto: prop.colaborador.fechaingresoproyecto.length > 0 ? format(parse(prop.colaborador.fechaingresoproyecto, "dd/MM/yyyy H:mm:ss", new Date()), "yyyy-MM-dd") : format(new Date(), 'yyyy-MM-dd'),
                    fechasalidaproyecto: prop.colaborador.fechasalidaproyecto.length > 0 ? format(parse(prop.colaborador.fechasalidaproyecto, "dd/MM/yyyy H:mm:ss", new Date()), "yyyy-MM-dd") : format(new Date(), 'yyyy-MM-dd'),
                    porcentajeparticipacion: prop.colaborador.porcentajeparticipacion,
                    //datos que no se guardan
                    resumen: '',
                    fechaIniProy: prop.fechainicio,
                    fechaFinProy: prop.fechafin
                }}
                validationSchema={validationSchema}
                onSubmit={save}
            >
                {({ setFieldValue, values, errors, touched, handleSubmit, handleChange, handleBlur }) => (
                    <Form onSubmit={handleSubmit}>
                        <Grid className='siempre' container spacing={2}>
                            {prop.idproyecto > 0 ?
                                <Grid item sx={{ m: 1 }} xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="h6" gutterBottom>
                                        <strong>Proyecto:</strong> {prop.titulo}
                                    </Typography>
                                    <Typography variant="h6" gutterBottom>
                                        <strong>Inicio:</strong> {format(new Date(prop.fechainicio), "yyyy-MM-dd")}
                                        <> - </>
                                        <strong>Fin:</strong> {format(new Date(prop.fechafin), "yyyy-MM-dd")}
                                    </Typography>
                                </Grid>
                                : <></>}
                            <Grid item sx={{ m: 1 }} xs={12} sm={6} md={3} lg={3}>
                                <Button aria-label="addEspol" variant="contained" color="info" onClick={handleOpenUserModal} endIcon={<FaRegAddressCard />} >
                                    Personal Espol
                                </Button>
                            </Grid>
                            <Grid item sx={{ m: 1 }} xs={12} sm={6} md={3} lg={3}></Grid>
                            {prop.idproyecto > 0 && (
                                <Grid item sx={{ m: 1 }} xs={12} sm={6} md={3} lg={3}>
                                    <Button aria-label="delete" variant="contained" color="success" onClick={handleOpenModal} endIcon={<AiOutlineUserAdd />}>
                                        Personal Proyecto
                                    </Button>
                                </Grid>
                            )}
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl sx={{ m: 1, width: '100%' }} >
                                    <Field
                                        as={TextField}
                                        name={'cedula'}
                                        label="Identificación: "
                                        variant="outlined"
                                        type="text"
                                        placeholder="0999999999"
                                        value={values.cedula}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        InputProps={{
                                            readOnly: values.tipocolaborador === 1,
                                        }}
                                        error={Boolean(errors.cedula && touched.cedula)}
                                    />
                                    <ErrorMessage name='cedula' className='errorMessage' component="div">
                                        {(error) => (
                                            <Alert severity="error">
                                                {error}
                                            </Alert>
                                        )}
                                    </ErrorMessage>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl sx={{ m: 1, width: '100%' }} >
                                    <TextField
                                        name={'nombre'}
                                        type="text"
                                        placeholder="Zambrano Herrera Zacarias Miguel"
                                        value={values.nombre}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        InputProps={{
                                            readOnly: values.tipocolaborador === 1,
                                        }}
                                        error={Boolean(errors.nombre && touched.nombre)}
                                    />
                                    <ErrorMessage name='nombre' className='errorMessage' component="div">
                                        {(error) => (
                                            <Alert severity="error">
                                                {error}
                                            </Alert>
                                        )}
                                    </ErrorMessage>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl sx={{ m: 1, width: '100%' }}>
                                    <InputLabel htmlFor="select-tipo">Tipo:</InputLabel>
                                    <Select
                                        name={'tipocolaborador'}
                                        label={'Tipo: '}
                                        variant="outlined"
                                        value={values.tipocolaborador}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={Boolean(errors.tipocolaborador && touched.tipocolaborador)}
                                    >
                                        {/* Agrega más roles según sea necesario */}
                                        <MenuItem key={'null-tipocolaborador'} value={0}>
                                            {'Seleccione tipo colaborador'}
                                        </MenuItem>
                                        {tipoColaborador.map((rol) => (
                                            <MenuItem key={rol.id} value={rol.id}>
                                                {rol.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <ErrorMessage name='tipocolaborador' className='errorMessage' component="div">
                                        {(error) => (
                                            <Alert severity="error">
                                                {error}
                                            </Alert>
                                        )}
                                    </ErrorMessage>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl sx={{ m: 1, width: '100%' }}>
                                    <Field
                                        as={TextField}
                                        label={'Correo: '}
                                        name={'email'}
                                        type="text"
                                        placeholder="example@espol.edu.ec"
                                        value={values.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        InputProps={{
                                            readOnly: values.tipocolaborador === 1,
                                        }}
                                        error={Boolean(errors.email && touched.email)}
                                    />
                                    <ErrorMessage name='email' className='errorMessage' component="div">
                                        {(error) => (
                                            <Alert severity="error">
                                                {error}
                                            </Alert>
                                        )}
                                    </ErrorMessage>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl sx={{ m: 1, width: '100%' }}>
                                    <InputLabel htmlFor="select-unidad">Rol: </InputLabel>
                                    <Select
                                        name={'tipoparticipacion'}
                                        label={'Rol: '}
                                        value={values.tipoparticipacion}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={Boolean(errors.tipoparticipacion && touched.tipoparticipacion)}
                                    >
                                        <MenuItem value="0">Seleccionar Rol</MenuItem>
                                        {/* Agrega más roles según sea necesario */}
                                        {listRolColaborador.map((rol) => (
                                            <MenuItem key={rol.id} value={rol.id}>
                                                {rol.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <ErrorMessage name='tipoparticipacion' className='errorMessage' component="div">
                                        {(error) => (
                                            <Alert severity="error">
                                                {error}
                                            </Alert>
                                        )}
                                    </ErrorMessage>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                {usoParticipacion(values.tipocolaborador) ?
                                    <FormControl sx={{ m: 1, width: '100%' }}>
                                        <Field
                                            as={TextField}
                                            label={'% Participación: '}
                                            name={'porcentajeparticipacion'}
                                            type="text"
                                            placeholder="100"
                                            value={values.porcentajeparticipacion}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={Boolean(errors.porcentajeparticipacion && touched.porcentajeparticipacion)}
                                        />
                                        <ErrorMessage name='porcentajeparticipacion' className='errorMessage' component="div">
                                            {(error) => (
                                                <Alert severity="error">
                                                    {error}
                                                </Alert>
                                            )}
                                        </ErrorMessage>
                                    </FormControl>
                                    : <></>}
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl sx={{ m: 1, width: '100%' }}>
                                    <Field
                                        as={TextField}
                                        label={'Fecha Ingreso: '}
                                        name={'fechaingresoproyecto'}
                                        type="date"
                                        value={values.fechaingresoproyecto}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={Boolean(errors.fechaingresoproyecto && touched.fechaingresoproyecto)}
                                    />
                                    <ErrorMessage name='fechaingresoproyecto' className='errorMessage' component="div">
                                        {(error) => (
                                            <Alert severity="error">
                                                {error}
                                            </Alert>
                                        )}
                                    </ErrorMessage>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl sx={{ m: 1, width: '100%' }}>
                                    <Field
                                        as={TextField}
                                        label={'Fecha Salida: '}
                                        name={'fechasalidaproyecto'}
                                        type="date"
                                        value={values.fechasalidaproyecto}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={Boolean(errors.fechasalidaproyecto && touched.fechasalidaproyecto)}
                                    />
                                    <ErrorMessage name='fechasalidaproyecto' className='errorMessage' component="div">
                                        {(error) => (
                                            <Alert severity="error">
                                                {error}
                                            </Alert>
                                        )}
                                    </ErrorMessage>
                                </FormControl>
                            </Grid>
                            {values.tipocolaborador === 2 ?
                                <></>
                                :
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <FormControl sx={{ m: 1, width: '100%' }}>
                                        <InputLabel htmlFor="select-unidad">Unidad:</InputLabel>
                                        <Select
                                            name={'idunidad'}
                                            label={'Unidad: '}
                                            value={values.idunidad}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={Boolean(errors.idunidad && touched.idunidad)}
                                        >
                                            {/* Agrega más roles según sea necesario */}
                                            <MenuItem key={"null-unidad-col"} value="0">Ninguna</MenuItem>
                                            {unidades.map((rol) => (
                                                <MenuItem key={rol.idunidad} value={rol.idunidad}>
                                                    {rol.nombreunidad}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        <ErrorMessage name='idunidad' className='errorMessage' component="div">
                                            {(error) => (
                                                <Alert severity="error">
                                                    {error}
                                                </Alert>
                                            )}
                                        </ErrorMessage>
                                    </FormControl>
                                </Grid>
                            }
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl sx={{ m: 1, width: '100%' }}>
                                    <Field
                                        as={TextField}
                                        label={'Institución: '}
                                        name={'institucion'}
                                        type="text"
                                        placeholder="Espol"
                                        value={values.institucion}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        InputProps={{
                                            readOnly: values.tipocolaborador === 1,
                                        }}
                                        error={Boolean(errors.institucion && touched.institucion)}
                                    />
                                    <ErrorMessage name='institucion' className='errorMessage' component="div">
                                        {(error) => (
                                            <Alert severity="error">
                                                {error}
                                            </Alert>
                                        )}
                                    </ErrorMessage>
                                </FormControl>
                            </Grid>
                            {values.tipocolaborador === 2 ?
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    {/* <FormControl sx={{ m: 1, width: '100%' }} >
                                        <TextField
                                            name={'resumen'}
                                            type="text"
                                            label="Resumen: "
                                            multiline
                                            rows={2}
                                            value={values.resumen}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={Boolean(errors.resumen && touched.resumen)}
                                        />
                                        <ErrorMessage name='resumen' className='errorMessage' component="div">
                                            {(error) => (
                                                <Alert severity="error">
                                                    {error}
                                                </Alert>
                                            )}
                                        </ErrorMessage>
                                    </FormControl> */}
                                </Grid>
                                :
                                <></>
                            }
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={3}>
                                <Button
                                    color="error"
                                    variant="contained"
                                    onClick={() => goToNavigation('/Producto/MisProductos')}
                                    endIcon={<MdAssignmentReturn />} >
                                    Regresar
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={3}>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={3}>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={3}>
                                <Button
                                    type='submit'
                                    variant="contained"
                                    endIcon={<RiSave3Fill />} >
                                    Guardar
                                </Button>
                            </Grid>
                        </Grid>
                        <ModalStrap isOpen={open} toggle={toggleOpen} className="custom-modal">
                            <ModalHeader toggle={toggleOpen}>
                                <Typography id="modal-modal-title" >Colaboradores Proyectos</Typography>
                            </ModalHeader>
                            <ModalBody>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>#</TableCell>
                                            <TableCell>Cedula</TableCell>
                                            <TableCell>Apellidos y Nombres</TableCell>
                                            <TableCell>Institucion</TableCell>
                                            <TableCell>Correo</TableCell>
                                            <TableCell>Accion</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {colaboradorProyecto.map((colaborador, index) => (
                                            <TableRow key={'colProy-' + index}>
                                                <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                <TableCell>
                                                    {colaborador.cedula}
                                                </TableCell>
                                                <TableCell>
                                                    {colaborador.nombre}
                                                </TableCell>
                                                <TableCell>
                                                    {colaborador.institucion}
                                                </TableCell>
                                                <TableCell>
                                                    {colaborador.email}
                                                </TableCell>
                                                <TableCell>
                                                    {isColaboradorDelProducto(colaborador) ?
                                                        <>Ya es colaborador</> :
                                                        <IconButton aria-label="add" color="info" onClick={() => handleAddColaborador(colaborador, setFieldValue)}>
                                                            <AiOutlinePlusCircle />
                                                        </IconButton>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </ModalBody>
                        </ModalStrap>
                        <ModalStrap isOpen={userModal} toggle={toggleModal} className="custom-modal">
                            <ModalHeader toggle={toggleModal}>
                                <Typography id="modal-modal-title" >Busqueda Usuario</Typography>
                            </ModalHeader>
                            <ModalBody>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink className={tap === 0 ? 'active' : ''} style={tabStyle}
                                            onClick={() => setTap(0)}
                                        >
                                            Email
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink className={tap === 1 ? 'active' : ''} style={tabStyle}
                                            onClick={() => setTap(1)}
                                        >
                                            Apellidos
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={tap}>
                                    <TabPane tabId={0}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={9} lg={9}>
                                                <TextField
                                                    id='busq-email'
                                                    type="email"
                                                    name='mailBusqueda'
                                                    label="Email"
                                                    sx={{ m: 1, width: '100%' }}
                                                    size="small"
                                                    value={mailBusqueda}
                                                    onChange={handleEmailBusquedaChange}
                                                    onBlur={handleEmailBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                                <Button variant="contained" style={buttonStyle} endIcon={<AiOutlineSearch />} onClick={() => { setListBusqueda('N', mailBusqueda) }}>Buscar</Button>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                {loadingModal ?
                                                    <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
                                                        <CircularProgress color="success" />
                                                    </Stack> :
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>#</TableCell>
                                                                <TableCell>Cedula</TableCell>
                                                                <TableCell>Apellidos y Nombres</TableCell>
                                                                <TableCell>Correo</TableCell>
                                                                <TableCell>Accion</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {busquedaUsuario.map((colaborador, index) => (
                                                                <TableRow key={'colProy-' + index}>
                                                                    <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                                    <TableCell>
                                                                        {colaborador.cedula}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {colaborador.nombre}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {colaborador.email}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {isColaboradorDelProducto(colaborador) ? <>Ya es colaborador</> :
                                                                            <IconButton aria-label="add" color="info" onClick={() => handleAddPersona(colaborador, setFieldValue)}>
                                                                                <AiOutlinePlusCircle />
                                                                            </IconButton>}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                            {busquedaUsuario.length == 0 ?
                                                                <TableRow key={'colProy-o'}>
                                                                    <TableCell></TableCell>
                                                                    <TableCell></TableCell>
                                                                    <TableCell>Sin resultados</TableCell>
                                                                    <TableCell></TableCell>
                                                                    <TableCell></TableCell>
                                                                </TableRow> : <></>
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                }
                                            </Grid>
                                        </Grid>
                                    </TabPane>
                                    <TabPane tabId={1}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={9} lg={9}>
                                                <TextField
                                                    id='busq-apellidos'
                                                    label="Apellidos"
                                                    sx={{ m: 1, width: '100%' }}
                                                    size="small"
                                                    value={apellidosBusqueda}
                                                    onChange={handleApellidosBusquedaChange}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                                <Button variant="contained" style={buttonStyle} endIcon={<AiOutlineSearch />} onClick={() => { setListBusqueda(apellidosBusqueda, 'N') }}>Buscar</Button>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                {loadingModal ?
                                                    <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
                                                        <CircularProgress color="success" />
                                                    </Stack> :
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>#</TableCell>
                                                                <TableCell>Cedula</TableCell>
                                                                <TableCell>Apellidos y Nombres</TableCell>
                                                                <TableCell>Correo</TableCell>
                                                                <TableCell>Accion</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {busquedaUsuario.map((colaborador, index) => (
                                                                <TableRow key={'colProy-' + index}>
                                                                    <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                                    <TableCell>
                                                                        {colaborador.cedula}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {colaborador.nombre}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {colaborador.email}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {isColaboradorDelProducto(colaborador)
                                                                            ? <>Ya es colaborador del producto</>
                                                                            : <IconButton aria-label="add" color="info" onClick={() => handleAddPersona(colaborador, setFieldValue)}>
                                                                                <AiOutlinePlusCircle />
                                                                            </IconButton>}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                            {busquedaUsuario.length == 0 ?
                                                                <TableRow key={'colProy-o'}>
                                                                    <TableCell></TableCell>
                                                                    <TableCell></TableCell>
                                                                    <TableCell>Sin resultados</TableCell>
                                                                    <TableCell></TableCell>
                                                                    <TableCell></TableCell>
                                                                </TableRow> : <></>
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                }
                                            </Grid>
                                        </Grid>
                                    </TabPane>
                                </TabContent>
                            </ModalBody>
                        </ModalStrap>
                    </Form>
                )}
            </Formik>
        </Box>
    )
}